import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoAgentVM } from '../../../Model/agents/DtoAgentVM';
import { AuthService } from '../../../Shared/Services/auth.service';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { environment } from '../../../../environments/environment';
import { AgentsService } from '../../../Services/agents.service';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { LoginVm } from '../../../Model/LoginVM';
import { SuppliersService } from '../../../Services/suppliers.service';
import { ViewSupplierComponent } from '../view-supplier/view-supplier.component';

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrl: './suppliers.component.scss'
})
export class SuppliersComponent {
private destroy$: Subject<boolean> = new Subject<boolean>();
  AllSuppliers: DtoAgentVM[] = [];
  OriginalSuppliers: DtoAgentVM[] = [];
  searchVal: String = '';
  imgPath: string = environment.ImgUrl;
  showEdit: boolean = false;

  constructor(private api: SuppliersService, private agentService: AgentsService, private auth: AuthService, private spinner: NgxSpinnerService,
    private toastrService: CustomToastrService, private router: Router,
    private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      this.spinner.show();
      this.GetAllSuppliers();
      let jsonObj = this.auth.getStorage("currentUser");
      const currentUser = <LoginVm>JSON.parse(jsonObj);
      this.showEdit = currentUser?.userType == UserType.Agent;
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllSuppliers() {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      this.api.GetAllSuppliers()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.AllSuppliers = res.result.payload;
              this.OriginalSuppliers = res.result.payload;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetFilteredList(event: any) {
    this.AllSuppliers = [];
    if (event.list?.length > 0) {
      this.AllSuppliers = event.list;
    }
  }

  EditSupplier(SupplierId?: number) {
    this.router.navigateByUrl('dashboard/edit-supplier/' + SupplierId);
  }

  ViewSupplier(SupplierId?: number) {
    const data = { 'selectedId': SupplierId };
    this.dialogService.openDialog(ViewSupplierComponent, data);
  }

  DeleteSupplier(SupplierId?: number) {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoDeleteThis',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.spinner.show();
        this.ConfirmDeleteSupplier(SupplierId);
      }
    });
  }

  ConfirmDeleteSupplier(SupplierId?: number) {
    this.agentService.DeleteAgent(SupplierId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          this.toastrService.showSuccessToast('Success', "DeletedSuccessfully");
          this.GetAllSuppliers();
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
  }
}
